<div
  class="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-ink/80 px-4 py-10"
  (click)="close()"
>
  <div
    class="w-full max-w-lg rounded-md border border-hairline bg-panel p-6"
    (click)="$event.stopPropagation()"
  >
    <div class="mb-4 flex items-start justify-between gap-4">
      <div>
        <h2 class="font-display text-xl font-semibold text-parchment">
          Edit {{ displayName() }}
        </h2>
        @if (!isCustom() && displayDescription(); as description) {
          <p class="mt-1 text-xs text-dusk">{{ description }}</p>
        }
      </div>
      <button
        type="button"
        (click)="close()"
        class="text-xl leading-none text-dusk hover:text-parchment"
        aria-label="Close"
      >
        &times;
      </button>
    </div>

    <form [formGroup]="form" (ngSubmit)="save()" class="flex flex-col gap-3">
      @if (isCustom()) {
        <label class="flex flex-col gap-1 text-sm">
          <span class="text-dusk">Name</span>
          <input
            formControlName="name"
            type="text"
            class="rounded border border-hairline bg-ink px-3 py-2 text-parchment focus:border-gold focus:outline-none"
          />
        </label>
        <label class="flex flex-col gap-1 text-sm">
          <span class="text-dusk">Description</span>
          <textarea
            formControlName="description"
            rows="2"
            class="rounded border border-hairline bg-ink px-3 py-2 text-parchment focus:border-gold focus:outline-none"
          ></textarea>
        </label>
      }

      <div class="grid grid-cols-2 gap-3">
        <label class="flex flex-col gap-1 text-sm">
          <span class="text-dusk">Award type</span>
          <select
            formControlName="awardType"
            class="rounded border border-hairline bg-ink px-3 py-2 text-parchment focus:border-gold focus:outline-none"
          >
            <option value="POINTS">Points</option>
            <option value="PRIZE">Prize</option>
          </select>
        </label>
        <label class="flex flex-col gap-1 text-sm">
          <span class="text-dusk">Distribution</span>
          <select
            formControlName="distributionMode"
            class="rounded border border-hairline bg-ink px-3 py-2 text-parchment focus:border-gold focus:outline-none"
          >
            <option value="DUPLICATED">Duplicated</option>
            <option value="SPLIT">Split</option>
          </select>
        </label>
      </div>
      <p class="text-xs text-dusk">
        Duplicated: everyone who wins gets the full award. Split: the award is shared among the
        winners — if only one person wins, they get all of it.
      </p>

      @if (form.controls.awardType.value === 'POINTS') {
        <label class="flex flex-col gap-1 text-sm">
          <span class="text-dusk">Points</span>
          <input
            formControlName="pointsValue"
            type="number"
            class="rounded border border-hairline bg-ink px-3 py-2 text-parchment focus:border-gold focus:outline-none"
          />
        </label>
      } @else {
        <label class="flex flex-col gap-1 text-sm">
          <span class="text-dusk">Prize description</span>
          <input
            formControlName="prizeDescription"
            type="text"
            class="rounded border border-hairline bg-ink px-3 py-2 text-parchment focus:border-gold focus:outline-none"
          />
        </label>
        <label class="flex flex-col gap-1 text-sm">
          <span class="text-dusk">Dollar value (optional)</span>
          <input
            formControlName="prizeDollarValue"
            type="number"
            class="rounded border border-hairline bg-ink px-3 py-2 text-parchment focus:border-gold focus:outline-none"
          />
        </label>
      }

      @if (errorMessage()) {
        <p class="rounded border border-wax/40 bg-wax/10 px-3 py-2 text-xs text-parchment">
          {{ errorMessage() }}
        </p>
      }

      <div class="mt-1 flex items-center gap-4">
        <button
          type="submit"
          [disabled]="saving()"
          class="inline-flex items-center justify-center rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-5 py-2 text-sm font-bold text-ink transition hover:-translate-y-px disabled:cursor-not-allowed disabled:opacity-60"
        >
          {{ saving() ? 'Saving…' : 'Save' }}
        </button>
        <button type="button" (click)="close()" class="text-sm text-dusk hover:text-parchment">
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>
